import styled from 'styled-components';
import { useLocalization } from '../custom-hooks/useLocalization';
import { device } from '../../utils/styled-component-mixins';
import SkeletonCard from './cards/SkeletonCard';
import NoResultsCard from '../shared/NoResultsCard';

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(35rem, 1fr));
  grid-template-rows: max-content;
  grid-gap: 1.6rem;
  position: relative;
  isolation: isolate;

  .widget-spacing-wrapper {
    margin-bottom: 0;
  }
`;

const SkeletonCards = () => Array.from(Array(20), (_, i) => <SkeletonCard key={i} />);

const InsightGrid = ({
  className,
  header,
  card: Card,
  cards,
  isLoading,
  hasMoreResults,
  showMore,
  advancedSearchLinkText,
  advancedSearchLink,
  indexKeyFunction,
  advancedSearchPrelinkText
}) => {
  const { resourceStrings } = useLocalization();
  const noResultsMessage = resourceStrings['bdO.InsightSectionWidget.NoResults'];

  return (
    <div className={className}>
      {header}
      <CardGrid>
        {isLoading ? (
          <SkeletonCards />
        ) : (
          cards.map((props) => <Card {...props} key={indexKeyFunction(props)} />)
        )}
      </CardGrid>
      {cards.length === 0 && (
        <div>
          <NoResultsCard className="no-results-card" noResultsMessage={noResultsMessage} />
        </div>
      )}
      <div className="cta-wrapper">
        {advancedSearchLink && advancedSearchLinkText && (
          <div className="advanced-search-cta">
            {advancedSearchPrelinkText && <p>{advancedSearchPrelinkText}</p>}
            <ButtonLink
              text={advancedSearchLinkText}
              link={advancedSearchLink}
              target="_self"
              type="tertiary"
              theme="light"
            />
          </div>
        )}
        {hasMoreResults && (
          <div className="show-more-container">
            <ButtonLink
              onClickFunction={showMore}
              text="SHOW MORE"
              type="secondary"
              theme="light"
              isButtonTag
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default styled(InsightGrid)`
  @media ${device.deviceOnly} {
    .select-input-wrapper {
      margin-inline: -1.5rem;
      padding-inline: 1.5rem;
      width: unset;
      max-width: unset;
    }
  }

  .cta-wrapper {
    display: flex;
    flex-direction: column-reverse;
    margin-top: 4rem;

    @media ${device.desktop} {
      flex-direction: column;
      margin-top: 0;
    }
  }

  .advanced-search-cta {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin-bottom: 8.3rem;

    @media ${device.desktop} {
      flex-direction: row;
      margin-bottom: 4rem;
      margin-top: 4rem;
    }

    a,
    p {
      font-size: 1.6rem;
      line-height: 2.4rem;
    }

    p {
      margin: 0;

      @media ${device.desktop} {
        margin-bottom: 1px;
        margin-right: 0.8rem;
      }
    }
  }

  .show-more-container {
    display: flex;
    justify-content: center;
    margin-bottom: 4rem;

    @media ${device.desktop} {
      margin: 4rem 0 8rem 0;
    }
  }

  .no-results-card {
    z-index: 1;
  }
`;
